import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { hasPermission } from '@core/auth/with-permissions';
import { withPermissions } from '../auth/with-permissions';
import { AuthStore } from '../services/auth.store';

/**
 * Stops the user from accessing the route if the user has none of the required permissions
 * The permissions are provided withPermissions(...) in the route data
 *
 * @see {@link withPermissions}
 */
export const permissionGuard: CanActivateFn = route => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const features = authStore.applicationFeatures();

  if (hasPermission(route.data, features)) {
    return true;
  }

  return router.createUrlTree(['/unauthorized']);
};
